import v4 from 'uuid/v4';
export var uniqueFileName = function (name, uniqueId) {
    var chunks = name.replace(/[\W_]+/g, ' ').split(' ');
    var extension = (chunks || []).pop();
    return (uniqueId
        ? uniqueId + "-" + v4() + "." + extension
        : chunks.join('-') + "-" + v4() + "." + extension).toLowerCase();
};
